var map = {
	"./ENFJ.png": 6793,
	"./ENFP.png": 9795,
	"./ENTJ.png": 2407,
	"./ENTP.png": 4829,
	"./ESFJ.png": 4376,
	"./ESFP.png": 5170,
	"./ESTJ.png": 2642,
	"./ESTP.png": 9288,
	"./INFJ.png": 7877,
	"./INFP.png": 9103,
	"./INTJ.png": 8976,
	"./INTP.png": 297,
	"./ISFJ.png": 5388,
	"./ISFP.png": 6182,
	"./ISTJ.png": 7830,
	"./ISTP.png": 5452,
	"./ckhycsjg.png": 612,
	"./cxcs.png": 5283,
	"./entp.png": 8221,
	"./fhcsjg.png": 1193,
	"./friendrst.png": 953,
	"./friendrst2.png": 4191,
	"./qs13.png": 5976,
	"./ydzf.png": 8463,
	"./yqhycs.png": 5441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;